import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../index.css";
import { Link } from "react-router-dom";
export default function Account() {
  return (
    <div className="account">
      <form>
        <div className="mb-3">
          <label htmlFor="exampleInputEmail1" className="form-label">
            Email address
          </label>
          <input
            type="email"
            className="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
          />
        </div>
        <div className="mb-3">
          <label htmlFor="exampleInputPassword1" className="form-label">
            Password
          </label>
          <input
            type="password"
            className="form-control"
            id="exampleInputPassword1"
          />
        </div>
        <div className="mb-3 form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="exampleCheck1"
          />
          <label className="form-check-label"htmlFor="exampleCheck1">
            Check me out
          </label>
        </div>
       <div className="form_btns">
       <button className="btn btn-primary mx-5 my-2">
          Sign In
        </button>
        <button className="btn btn-primary mx-5 my-2">
          Sign Up
        </button>
       </div>
<div className="go_home">
<Link className="link_" to={'/'}>go to home page</Link>

</div>
      </form>
    </div>
  );
}
